var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66634 7.66701C9.66634 6.43921 8.69634 5.44434 7.50011 5.44434C6.30301 5.44434 5.33301 6.43921 5.33301 7.66701C5.33301 8.8939 6.30301 9.88878 7.50011 9.88878C8.69634 9.88878 9.66634 8.8939 9.66634 7.66701Z",
    stroke: "#1D8BF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49958 17C6.4609 17 1 12.4652 1 7.72292C1 4.01034 3.90949 1 7.49958 1C11.0897 1 14 4.01034 14 7.72292C14 12.4652 8.53826 17 7.49958 17Z",
    stroke: "#1D8BF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocation);
export default __webpack_public_path__ + "static/media/BlueLocation.10efb177ae947a0a7758af6401453368.svg";
export { ForwardRef as ReactComponent };